import React, {useMemo, useState} from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from "../LoadingSpinner";
import EmptyBanner from "../EmptyBanner";
import {useQueryClient} from '@tanstack/react-query';


import Meeting, { cancelMeetingForTalentOpp } from "../../models/Meeting";

import ErrorBanner from "../ErrorBanner";
import OppMeetingRow from "./components/OppMeetingRow";
import MeetingStatusFilter from "./components/MeetingStatusFilter";
import {useOpportunity} from "../../providers/OpportunityProvider";
import {useAPI} from "../../config/API";

const ManageOppMeetings = (props) => {
    const {
        opportunity
    } = useOpportunity();

    const activeTalentCandidateId = (props.opportunity || opportunity)?.job_candidate?.id;
    const editable = opportunity.canEditProposal();
    const queryClient = useQueryClient()
    const [isLoading, setIsLoading] = useState(false);
    const [selectedStatuses, setSelectedStatuses] = useState(TB.filter([...laravel.meeting_statuses], status => status !== 'Past'));

    const {
        data: meetings,
        isFetching,
        error,
        refetch
    } = useAPI(
        ['fetchMeetings', {candidateId: activeTalentCandidateId}], {
            refetchOnMount: true,
            enabled: TB.isDefined(activeTalentCandidateId)
        }
    );


    const handleCancelMeeting = async (meetingId, reasonId) => {
        setIsLoading(true);
        const res = await cancelMeetingForTalentOpp(activeTalentCandidateId, meetingId, reasonId).catch(err => {
            setIsLoading(false);
            return TB.showServerErrorToast();
        });

        if (res) {
            TB.toast("Interview successfully cancelled", {type: 'success'});

            await queryClient.invalidateQueries({
                predicate: ({queryKey}) => {
                    const params = queryKey[1] || {};

                    return queryKey[0] === 'fetchMeetings' &&
                        params.candidateId === activeTalentCandidateId
                }
            })

            await queryClient.invalidateQueries({
                predicate: ({queryKey}) => {
                    const params = queryKey[1] || {};

                    return queryKey[0] === 'getConversation' &&
                        params.candidateId === activeTalentCandidateId
                }
            })
        }
        setIsLoading(false);
    }

    let visibleMeetings = useMemo(() => {
        if (!meetings?.length) {
            return [];
        }
        if (!selectedStatuses?.length) {
            return meetings;
        } else {
            return TB.filter(meetings, meeting => TB.includes(selectedStatuses, meeting.status))
        }
    }, [selectedStatuses?.length, meetings]);


    return (
        <div id="interviews-table-popup-boundary"
             className="proposal-padding flex flex-col items-stretch flex-1 h-full p-2">
            <div className="flex flex-row items-center" style={{gap: 16}}>
                <h3 className="proposal-tab-header">Interviews</h3>

                {!!meetings?.length && !error && selectedStatuses && (
                    <MeetingStatusFilter
                        meetings={meetings}
                        selectedStatuses={selectedStatuses}
                        onChange={setSelectedStatuses}/>
                )}

            </div>

            {(!isFetching && error) && (
                <ErrorBanner title="Something went wrong" message="Failed to load interviews"
                             onRetry={refetch}/>
            )}

            {(!isFetching && !meetings?.length) && (
                <EmptyBanner message={"No Interviews Yet"}/>
            )}

            {(!!meetings?.length && !error) && (

                <div>
                    <table className="interviews-table w-full">
                        <thead className="border-b">
                            <tr>
                                <th className="p-2.5">Name</th>
                                <th className="p-2.5">Who</th>
                                <th className="p-2.5">When</th>
                                <th className="p-2.5">Status</th>
                                <th className="p-2.5"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {!!visibleMeetings?.length ? visibleMeetings.map(meeting => (
                                <OppMeetingRow
                                    key={`meeting-${meeting.id}`}
                                    meeting={meeting}
                                    opportunity={opportunity}
                                    activeTalentCandidateId={activeTalentCandidateId}
                                    onUpdate={props => {
                                        let newMeeting = Meeting.make({
                                            ...meeting, ...props
                                        });
                                        queryClient.setQueryData(['fetchMeetings',
                                            {candidateId: activeTalentCandidateId}
                                        ], data => {
                                            if (!data) return undefined;

                                            return TB.map(data, item => item.id === newMeeting?.id ? newMeeting : item)
                                        })
                                    }}
                                    onCancel={handleCancelMeeting}
                                />
                            )) : (
                                <tr>
                                    <td colSpan={5}>
                                        <p className="mb-0 text-center">
                                            No interviews found. Update or change the selected filters
                                        </p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {(isFetching || isLoading) && (
                <div className="w-full flex justify-center position-absolute"
                     style={{bottom: 0, top: 0, zIndex: 2, paddingTop: 80, background: 'rgba(255,255,255,0.5)'}}>
                    <LoadingSpinner/>
                </div>
            )}
        </div>
    )
};

ManageOppMeetings.propTypes = {
    position: PropTypes.any,
    candidate: PropTypes.any,
    opportunity: PropTypes.any,
    disabled: PropTypes.any
}

export default ManageOppMeetings



// const MeetingsTable = (props) => {
//
//     const {
//         opportunity
//     } = useOpportunity();
//
//     const {auth} = useAuth();
//     const activeTalentCandidateId = (props.opportunity || opportunity)?.job_candidate?.id;
//     const editable = opportunity.canEditProposal();
//     const queryClient = useQueryClient()
//     const [isLoading, setIsLoading] = useState(false);
//     const [selectedStatuses, setSelectedStatuses] = useState(TB.filter([...laravel.meeting_statuses], status => status !== 'Past'));
//
//     const [selectedMeeting, setSelectedMeeting] = useState(null)
//     const [isDetailsOpen, setIsDetailsOpen] = useState(false);
//
//
//     const closeModal = async () => {
//         try {
//             await setIsDetailsOpen(false);
//             await TB.wait(200);
//             await setSelectedMeeting(null);
//         }catch (e) {
//
//         }
//     }
//     const popupContentRef = useRef(null);
//
//     const openPopup = async(meeting) => {
//         try {
//             await setSelectedMeeting(meeting);
//             await TB.wait(200);
//             setIsDetailsOpen(true);
//         }catch (e) {
//
//         }
//     }
//     const scheduleSelectedMeeting = (e) => {
//         if (e) e.stopPropagation();
//
//         return TB.event("Modal@show", {
//             modalClass: "schedule-meeting-modal talent-confirmation",
//             defaultScroll: false,
//             content: (
//                 <ScheduleMeetingModal
//                     meeting={selectedMeeting}
//                     activeTalentCandidateId={activeTalentCandidateId}
//                     opportunity={opportunity}
//                     onClose={() => TB.event("Modal@hide")}/>
//             )
//         })
//     }
//     return (
//         <React.Fragment>
//
//             <ATable
//                 // scroll={{x: TB.sum(TB.values(columnWidths))}}
//                 pagination={false}
//                 rowKey='id'
//                 className="interviews-table"
//                 dataSource={visibleMeetings}
//                 onRow={(record, rowIndex) => {
//                     return {
//                         onClick: async(event) => {
//                             if (isDetailsOpen) {
//                                 await closeModal();
//                             }
//                             return openPopup(record)
//                         }, // click row
//                         onDoubleClick: (event) => {}, // double click row
//                         onContextMenu: (event) => {}, // right button click row
//                         onMouseEnter: (event) => {}, // mouse enter row
//                         onMouseLeave: (event) => {}, // mouse leave row
//                     };
//                 }}
//             >
//
//                 <ATable.Column
//                     title="Name"
//                     dataIndex="name"
//                     key="name"
//                     fixed="left"
//                     width={200}
//                     render={name => (
//                         <div className="interview-name text-ellipsis ">
//                             <p>{name}</p>
//                         </div>
//                     )}
//                 />
//                 <ATable.Column
//                     title="Who"
//                     dataIndex="creator"
//                     key="creator"
//                     // width={columnWidths.Member}
//                     render={(creator, meeting) => {
//                         let attendees = TB.filter(meeting.members || [], member => {
//                             return member.id !== creator.id
//                         });
//                         return (
//                             <div className="flex flex-row items-center justify-start gap-2">
//                                 <UserImageCircle
//                                     user={creator}
//                                     hideTooltip={true}
//                                     className="img-grayscale"
//                                     size={36}/>
//                                 {!!attendees.length && (
//                                     <span className="attendee-count whitespace-no-wrap"
//                                           id={`max-members-${meeting.id}`}>
//                                         {`+You${attendees.length > 1 ? `, ${attendees.length - 1} more` : ''}`}
//                                     </span>
//                                 )}
//                             </div>
//                         )
//                     }}
//                 />
//                 <ATable.Column
//                     title="When"
//                     dataIndex="started_at"
//                     key="started_at"
//                     // width={columnWidths.Member}
//                     render={(started_at, meeting) => {
//
//                         const scheduleMeeting = (e) => {
//                             if (e) e.stopPropagation();
//
//                             return TB.event("Modal@show", {
//                                 modalClass: "schedule-meeting-modal talent-confirmation",
//                                 defaultScroll: false,
//                                 content: (
//                                     <ScheduleMeetingModal
//                                         meeting={meeting}
//                                         activeTalentCandidateId={activeTalentCandidateId}
//                                         opportunity={opportunity}
//                                         onClose={() => TB.event("Modal@hide")}/>
//                                 )
//                             })
//                         }
//                         return (
//                             <div className="whitespace-nowrap">
//                                 {meeting.awaitingConfirmationByTalent() && auth.canManageTalentOppInterviews() && (
//                                     <button className="btn btn-primary" onClick={scheduleMeeting} disabled={props.disabled}>
//                                         {meeting.rescheduled_at ? "Update Availability" : "Confirm Availability"}
//                                     </button>
//                                 )}
//
//                                 {!meeting.awaitingConfirmationByTalent() && meeting.acceptedTime()}
//                             </div>
//                         )
//                     }}
//                 />
//
//                 <ATable.Column
//                     title="Status"
//                     dataIndex="status"
//                     key="status"
//                     width={100}
//                     render={(status, meeting) => (
//                         <div className={"meeting-status whitespace-nowrap " + meeting.statusClass()}>
//                             {meeting.statusName()}
//                         </div>
//                     )}
//                 />
//                 <ATable.Column
//                     title={null}
//                     dataIndex="id"
//                     key="id"
//                     // width={columnWidths.Member}
//                     render={(id, meeting) => {
//
//                         const canCancel = !meeting.hasExpired()
//                             && !meeting.rejected_at
//                             && meeting.status !== 'Completed'
//                             && auth.canManageTalentOppInterviews();
//
//                         if (!canCancel) return null;
//
//                         return (
//                             <UncontrolledDropdown direction="down">
//                                 <DropdownToggle
//                                     tag="span"
//                                     className="clickable" style={{pointerEvents: 'all'}}
//                                     onClick={e => {
//                                         e.stopPropagation();
//                                         // if (isDetailsOpen) closeModal();
//                                     }}>
//                                     <i className="fas fa-ellipsis-v p-2"></i>
//                                 </DropdownToggle>
//                                 <DropdownMenu container="body">
//                                     {canCancel && (
//                                         <DropdownItem
//                                             onClick={e => {
//                                                 e.stopPropagation()
//                                                 return handleCancelMeeting(meeting.id, Meeting.talent_cancelled_reason()?.value)
//                                                 // if (isDetailsOpen) closeModal();
//                                             }}
//                                             disabled={props.disabled}>
//                                             Cancel
//                                         </DropdownItem>
//                                     )}
//                                 </DropdownMenu>
//                             </UncontrolledDropdown>
//                         )
//                     }}
//                 />
//
//             </ATable>
//             {selectedMeeting && (
//                 <Popup
//                     key={`open-meeting-${selectedMeeting.id}`}
//                     position={['center center', 'center right', 'center bottom', 'right center', 'right bottom', 'center center']}
//                     keepTooltipInside={'.proposal-container'}
//                     // ref={popupRef}
//                     closeOnDocumentClick
//                     open={isDetailsOpen}
//                     onClose={closeModal}>
//                     <MeetingPopup
//                         meeting={selectedMeeting}
//                         viewerType="talent"
//                         onConfirm={async(e) => {
//                             e.stopPropagation();
//                             await setIsDetailsOpen(false)
//                             await scheduleSelectedMeeting();
//                             return closeModal();
//                         }}
//                         onCancel={() => props.onCancel(selectedMeeting.id, Meeting.talent_cancelled_reason()?.value)}
//                         onClose={() => closeModal()}
//                         actionable={false}
//                         canReschedule={false}
//                         ref={popupContentRef}/>
//                 </Popup>
//             )}
//         </React.Fragment>
//     )
// }